import { render, staticRenderFns } from "./Adjustment.vue?vue&type=template&id=54d64666"
import script from "./Adjustment.vue?vue&type=script&lang=js"
export * from "./Adjustment.vue?vue&type=script&lang=js"
import style0 from "./Adjustment.vue?vue&type=style&index=0&id=54d64666&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports